<template>
  <MainLayout :navBar="false" hide-footer>
    <v-layout style="background: var(--primary)" fill-height column>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs10 sm10 md5 lg4 xl3>
          <v-layout column>
            <v-card style="border-radius: 0.625em" light color="#f4f4fa">
              <v-container class="login-form">
                <v-layout fill-weight column class="mx-5">
                  <v-layout
                    align-center
                    column
                    class="mt-2"
                    style="margin-bottom: 2.5em"
                  >
                    <!-- <img
                      class="login-logo"
                      src="@/assets/images/uplabdh_logo_clear.png"
                    /> -->
                  </v-layout>

                  <!-- Email -->
                  <v-text-field
                    outline
                    prepend-inner-icon="mail_outline"
                    v-model="loginForm.email"
                    hint="Email"
                    placeholder="Email"
                    label="Email"
                    :error-messages="errors.email"
                    single-line
                  />

                  <!-- Password -->
                  <v-text-field
                    outline
                    prepend-inner-icon="lock_open"
                    :append-icon="show_pwd ? 'visibility_off' : 'visibility'"
                    :type="show_pwd ? 'text' : 'password'"
                    @click:append="show_pwd = !show_pwd"
                    v-model="loginForm.password"
                    single-line
                    @keyup.enter="attemptLogin"
                    :error-messages="errors.password"
                    label="Password"
                    hint="Password"
                    placeholder="Password"
                  />

                  <!-- Platform -->
                  <v-select
                    outline
                    label="Platform"
                    v-model="loginForm.platform"
                    :items="platforms"
                    hide-details
                  />

                  <!-- Forgot Password -->
                  <RouterLink class="my-2" :to="{ name: 'forgot-password' }">
                    Lost your password?
                  </RouterLink>

                  <!-- Submit -->
                  <div
                    style="width: 100%; justify-content: center; display: flex"
                  >
                    <v-btn
                      style="padding: 0 3.75em"
                      :loading="loginRequesting"
                      dark
                      large
                      depressed
                      color="primary"
                      @click="attemptLogin"
                      >Login</v-btn
                    >
                  </div>
                </v-layout>
              </v-container>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout style="padding: 0.625em" column align-center justify-center>
        <img
          class="login-footer-logo"
          src="@/assets/images/footer-logo-2.png"
        />
        <div class="login-footer-text">
          Technology Powered by:
          <strong>&copy;SRSAC Govt. of Arunachal Pradesh</strong>
        </div>
      </v-layout>
    </v-layout>
  </MainLayout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { PLATFORMS } from "../../constants/platforms";

export default {
  metaInfo: {
    title: "Login",
    meta: [{ name: "Login", content: "login, sign in page" }]
  },

  data() {
    return {
      show_pwd: false,
      errors: {
        email: [],
        password: []
      },

      loginForm: {
        email: "",
        password: "",
        platform: PLATFORMS.ADMINISTRATION
      },

      platforms: [
        PLATFORMS.ADMINISTRATION,
        PLATFORMS.DEPARTMENT,
        PLATFORMS.DISTRICT
      ],

      loginRequesting: false
    };
  },

  computed: {
    ...mapState("auth", ["rememberMe", "currentUser"]),

    rememberToken: {
      get() {
        return this.rememberMe;
      },
      set(value) {
        this.$store.commit("auth/REMEMBER_ME", value);
      }
    }
  },

  created() {
    this.rememberToken = true;
  },

  methods: {
    ...mapActions("auth", ["logIn", "getMe"]),

    async attemptLogin() {
      try {
        this.errors = {};

        this.loginRequesting = true;

        await this.logIn(this.loginForm);

        let redirectAfterLogin = "/";

        if (this.loginForm.platform === PLATFORMS.ADMINISTRATION) {
          redirectAfterLogin = "/dashboard";
        } else if (this.loginForm.platform === PLATFORMS.DEPARTMENT) {
          redirectAfterLogin = "/complaints";
        } else if (this.loginForm.platform === PLATFORMS.DISTRICT) {
          redirectAfterLogin = "/dashboard";
        }

        this.$router.replace(this.$route.query.redirect || redirectAfterLogin);
      } catch (e) {
        console.error(e);
        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error({
            title: "Login Failed",
            message: e.message
          });
        }
      } finally {
        this.loginRequesting = false;
      }
    }
  }
};
</script>
<style lang="css">
.login-form .v-input__slot {
  border: 0.0625em solid rgba(0, 0, 0, 0.44) !important;
}
</style>
<style lang="css" scoped>
.login-logo {
  width: 100%;
}
.login-footer-logo {
  height: 3.5em;
}
.login-footer-text {
  text-align: center;
  color: #013986;
  margin-top: 0.625em;
}
</style>
